export default "__VITE_ASSET__BbVaozj4__"